/**
 * 全局mixins对象, 在main.js中全局注入Vue
 * */

import Http from './http'
import Tools from './tools'
import methods from './methods'
import filters from './filters'
import directives from './directives'
import Sign from './http/sign'

const mixins = {
  computed: {
    Product() {
      return {
        product_id: 13,
        channel_id: 26,
        terminal_id: 6,
        // ...{"uid": 10342897, "product_id": 1, "channel_id": 23, "terminal_id": 5}
      };
    },
  },
  data() {
    return {
      http: Http,
      Tools,
      Sign,
    }
  },
  methods: {
    $err: Http.$err,
    ...methods,
  },
  directives: {
    ...directives,
  },
  filters: {
    ...filters,
  },
};

export default mixins